import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'yes_how_many_subcontractors'

export const dataPointDefinition = {
  retracedId: 'yes_how_many_subcontractors',
  name: 'If yes, how many subcontractors?',
  description: '',
  meta: {
    slcpMeta: {
      key: 'fp-sub-2',
      number: 'FP-SUB-2',
      dataType: 'numeric-whole',
      masterType: 'Question',
      multiSelectKey: '',
      optionList: '',
      versionImported: '1.7.0',
      verificationTypeReq: 'Facility Profile',
      verificationSelectionOptList: 'verf-f-list',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: '[1],fp-sub-1,Yes',
      machineShowHide: '[1],fp-sub-1,1',
      completionCondition: 'any',
    },
  },
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fp-sub-2', version: '1.7.0', provider: 'slcp'}],
  sortingId: 28970,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
